import { findRecursive } from '@/mm/utils.js'
import { washDataArabic, washDataArabicAlign, ArabicEach } from '@/mm/utils.js'

export function washData_relatedCarouselCase(walkedNode) {
  const ProNode = findRecursive(
    walkedNode.list,
    (item) => item.componentName === 'text_title',
    'list'
  )
  const buttonNode = findRecursive(
    walkedNode.list,
    (item) => item._type === 'button_text_1',
    'list'
  )
  if (walkedNode._type === 'related_carousel_case1') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    let ArabicRule = [
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
    getNodeByFlag(walkedNode,'abstract').forceShowEye = true
  } else if (walkedNode._type === 'related_carousel_case2') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    getNodeByFlag(walkedNode,'abstract').forceShowEye = true
    let ArabicRule = [
      {
        flag: 'related_title',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
  } else if (walkedNode._type === 'related_carousel_case3') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (buttonNode) {
      if (!buttonNode.actions.find((item) => item === 'translate')) {
        buttonNode.actions.push('translate')
      }
    }
    let ArabicRule = [
      {
        flag: 'related_title',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'name',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      },
      {
        flag: 'abstract',
        dataType: ['design','design'],
        onlyEnglish: ['title_textAlign',false],
        englishTitleLeft: ['left','self_marginLeft'],
        englishTitleRight: ['right','self_marginRight'],
      },
      {
        flag: 'more',
        dataType: ['design'],
        onlyEnglish: [false],
        englishTitleLeft: ['self_marginLeft'],
        englishTitleRight: ['self_marginRight'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
  } else if (walkedNode._type === 'related_carousel_case4') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (buttonNode) {
      if (!buttonNode.actions.find((item) => item === 'translate')) {
        buttonNode.actions.push('translate')
      }
    }
    let ArabicRule = [
      {
        flag: 'related_title',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'more',
        dataType: ['design'],
        onlyEnglish: ['self_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
  }
}
